import { ButtonGroup, styled } from '@mui/material';

const ToolbarButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
}));

export default ToolbarButtonGroup;
